/**
 * AuthImagePanel — the login side-panel visual (Figma 360:7558). A CSS gradient
 * backdrop (warm beige → indigo) with a floating white "creator analysis" card
 * composed of three stacked product screenshots (creator header, Brand Safety,
 * Audience Demographics). Replaces the earlier hero video on the Login screen.
 *
 * The card is positioned per Figma: left 84.5px / top 105px of the 537×796
 * panel and slightly larger than it, so it bleeds off the right + bottom edges
 * (clipped by the panel's overflow-hidden). Positions are expressed as % of the
 * panel so they hold as the fixed-aspect panel scales.
 *
 * Screenshots are public PNGs on the prod media bucket (`branding/login/`).
 */

const BASE = 'https://discovr-prod-media.s3.ap-south-1.amazonaws.com/branding/login';

/** Public asset URLs for the login card screenshots. */
export const AUTH_IMAGE_ASSETS = {
  creatorHeader: `${BASE}/creator-header.png`,
  brandSafety: `${BASE}/brand-safety.png`,
  audience: `${BASE}/audience.png`,
} as const;

/** Beige → indigo backdrop, sampled from the Figma background (top → bottom). */
const AUTH_BG_GRADIENT =
  'linear-gradient(180deg, #f2e9e2 0%, #ebd8c1 15%, #d3ba9e 30%, #8f8bb0 50%, #3a4a8c 70%, #172252 85%, #081134 100%)';

export function AuthImagePanel() {
  return (
    <div
      className="relative size-full overflow-hidden rounded-3xl"
      style={{ background: AUTH_BG_GRADIENT }}
    >
      {/* Floating creator-analysis card — larger than the panel, offset from the
          top-left so it bleeds off the right + bottom (Figma 360:7558). */}
      <div className="absolute top-[13.2%] left-[15.7%] w-[101.1%] rounded-xl bg-white p-2 shadow-[0px_20px_44px_-10px_rgba(0,0,0,0.16)]">
        <div className="flex flex-col gap-2">
          <img src={AUTH_IMAGE_ASSETS.creatorHeader} alt="" aria-hidden className="w-full rounded-[6px]" />
          <img src={AUTH_IMAGE_ASSETS.brandSafety} alt="" aria-hidden className="w-full rounded-[6px]" />
          <img src={AUTH_IMAGE_ASSETS.audience} alt="" aria-hidden className="w-full rounded-[6px]" />
        </div>
      </div>
    </div>
  );
}
